// @ts-nocheck

import palette from '../palette';

export const History = {
  labelColor: palette.white,
  pagination: {
    color: palette.neutralgrey450,
    bulletColor: palette.white,
  },
  historyFilterButton: {
    color: palette.white,
    border: '#313444',
    background: palette.black,
    activeBorder: palette.white,
    switchBackground: palette.bluegrey900,
    switchColor: palette.bluegrey400,
    switchActiveBackground: palette.bluegrey700,
    switchActiveColor: palette.white,
    live: {
      backgroundColor: palette.yellowwinamax450,
    },
    win: {
      backgroundColor: palette.greenwinamax450,
    },
    finished: {
      backgroundColor: palette.white,
    },
    active: {
      color: palette.black,
      borderColor: palette.transparent,
    },
    inactive: {
      color: palette.neutralgrey200,
      backgroundColor: palette.black,
      borderColor: palette.bluegrey800,
    },
  },
  outcome: {
    borderColor: palette.bluegrey850,
    arrow: {
      color: palette.neutralgrey300,
    },
    content: {
      bankerBackgroundColor: palette.bluegrey800,
      bankerColor: '#c1c9cf',
      checkmarkColor: palette.white,
      oddColor: palette.white,
      oddBackgroundColor: '#1a264d',
      initialOddColor: palette.bluegrey500,
      initialOddBackgroundColor: palette.bluegrey850,
    },
    match: {
      color: palette.white,
      liveScoreColor: palette.yellowwinamax350,
      endedScoreColor: palette.bluegrey200,
      timerColor: palette.yellowwinamax350,
      dateColor: '#888b8d',
    },
    footer: {
      color: palette.neutralgrey200,
      oddColor: palette.white,
      initialOddColor: palette.neutralgrey550,
      backgroundColor: palette.bluegrey850,
      matchScoreColor: palette.yellowwinamax450,
      voidBackgroundColor: palette.bluegrey750,
      cardBackgroundColor: palette.bluegrey900,
    },
    defaultContent: {
      color: palette.white,
      titleColor: palette.neutralgrey400,
      outcomeRunningColor: palette.yellowwinamax300,
      outcomeWinColor: palette.greenwinamax300,
      outcomeLostColor: palette.red100,
      outcomeCancelledColor: palette.white,
      defaultOutcomeColor: palette.neutralgrey350,
    },
    boostedContent: {
      oddColor: palette.neutralgrey550,
    },
    mymatchContent: {
      default: palette.white,
      outcomeRunningColor: palette.white,
      outcomeWinColor: palette.greenwinamax450,
      outcomeLostColor: palette.red100,
      outcomeCancelledColor: palette.white,
      betTitleColor: palette.neutralgrey400,
      bulletsColor: palette.white,
    },
    betResult: {
      color: palette.white,
      backgroundColor: palette.bluegrey800,
    },
  },
  betslip: {
    backgroundColor: palette.bluegrey900,
    color: palette.white,
    header: {
      color: palette.white,
      running: {
        backgroundColor: palette.yellowwinamax900,
        color: palette.yellowwinamax350,
      },
      win: {
        backgroundColor: palette.greenwinamax900,
        color: palette.greenwinamax350,
      },
      lost: {
        backgroundColor: palette.redwinamax900,
        color: palette.redwinamax350,
      },
      cancelled: {
        backgroundColor: palette.bluegrey900,
        color: palette.bluegrey700,
      },
      button: {
        backgroundColor: palette.bluegrey900,
        color: palette.white,
      },
      detail: {
        backgroundColor: palette.bluegrey900,
        color: palette.neutralgrey300,
        dotsColor: palette.bluegrey500,
      },
    },
    outcome: {
      borderColor: palette.bluegrey800,
      selectedBorderColor: palette.white,
      color: palette.white,
      boostedBackground: palette.bluegrey850,
      arrowBackground: palette.bluegrey800,
      win: {
        color: palette.greenwinamax350,
      },
      cancelled: {
        color: palette.bluegrey500,
      },
      live: {
        color: palette.yellowwinamax350,
      },
      running: {
        color: palette.bluegrey350,
      },
      lost: {
        color: palette.redwinamax350,
      },
    },
    summary: {
      backgroundColor: palette.bluegrey850,
      color: palette.white,
      detailsColor: palette.neutralgrey350,
      oddRowBackgroundColor: palette.bluegrey950,
      oddRowBorderRadius: '6px',
      totalOddsColor: palette.neutralgrey200,
      separatorColor: palette.bluegrey800,
      yellowRow: palette.yellowwinamax350,
      greenRow: palette.greenwinamax350,
      redRow: palette.red100,
      compact: {
        labelColor: palette.neutralgrey300,
        valueColor: palette.white,
      },
    },
    system: {
      borderColor: palette.bluegrey400,
      color: palette.white,
    },
    actions: {
      buttonColor: palette.black,
      cashoutButtonBackgroundColor: palette.yellowwinamax450,
      completeButtonBackgroundColor: palette.white,
    },
    footer: {
      color: palette.neutralgrey400,
      referenceLabelColor: palette.neutralgrey200,
      backgroundColor: palette.bluegrey850,
    },
    hallOfFame: {
      color: palette.white,
    },
  },
};
